import React from "react";
import "./HousekeepingServices.css";

// 👉 Replace with your own small icon
import ServiceIcon from "../../Image/HouseKeeping/rightthick.png";

const services = [
  "Cockroach control & elimination",
  "Rodent management & prevention",
  "Termite treatments & protection",
  "Ant control services",
  "Mosquito control",
  "Fly control & management",
  "Spider control",
  "Bed bug treatments",
  "General pest control",
  "Pre-construction termite treatment",
  "Preventive pest management",
  "Pest audits & monitoring",
];


const steps = [
  {
    number: "01",
    title: "Inspection & Assessment",
    desc: "Thorough inspection to identify pest types, infestation levels, and entry points.",
  },
  {
    number: "02",
    title: "Treatment Plan",
    desc: "Create customized treatment plan using appropriate methods and safe chemicals",
  },
  {
    number: "03",
    title: "Treatment Execution",
    desc: "Apply targeted treatments using modern equipment and techniques",
  },
  {
    number: "04",
    title: "Follow-up & Prevention",
    desc: "Monitor results, provide follow-up treatments, and implement preventive measures",
  },
];

const CorporatePestControlServices = () => {
  return (
    <>
      {/* ---------------- SERVICES SECTION ---------------- */}
      <section className="hk-services-section">
        <h2 className="hk-section-title">Our Service Includes</h2>

        <div className="hk-services-grid">
          {services.map((item, index) => (
            <div key={index} className="hk-service-card">
              <img src={ServiceIcon} alt="service" className="hk-service-img" />
              <span>{item}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ---------------- PROCESS SECTION ---------------- */}
      <section className="hk-process-section">
        <div className="hk-process-tag">Our Process</div>
        <h2 className="hk-section-title">Our Pest Control Process</h2>

        <div className="hk-process-grid">
          {steps.map((step, index) => (
            <div key={index} className="hk-process-card">
              <div className="hk-process-number">{step.number}</div>
              <h4>{step.title}</h4>
              <p>{step.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default CorporatePestControlServices;
